import { AuthUserModel } from '@/models/auth-user.model';
import BaseService from '@/services/base-service';
import SessionService from '@/services/session.service';
import HttpService from './http.service';

export default class AuthService extends BaseService {
  constructor(httpService: HttpService) {
    super(httpService);
  }

  async login(username: string, password: string): Promise<AuthUserModel> {
    const result = (await this.httpService.post(AuthUserModel, `${this.apiUrl}/auth/authenticate`, {
      username,
      password,
    })) as AuthUserModel;

    if (result) {
      SessionService.startSession(result);
      this.httpService.reconfigureAxios();
    }

    return result;
  }

  logout(): void {
    SessionService.destroySession();
  }
}
